import { render, staticRenderFns } from "./Internal-Incident-Report.vue?vue&type=template&id=3d8a6378"
import script from "./Internal-Incident-Report.vue?vue&type=script&lang=js"
export * from "./Internal-Incident-Report.vue?vue&type=script&lang=js"
import style0 from "./Internal-Incident-Report.vue?vue&type=style&index=0&id=3d8a6378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports